import { atom } from "recoil";

const roundState = atom<number>({
  key: "roundState",
  default: 0,
});

export default roundState;
